import FeedbackPage from '@/components/FeedbackPage'
import { getChallengeFeedback } from '@/utils/feedbackContent'

export default function ChallengeFeedbackPage() {
  return <FeedbackPage {...getChallengeFeedback()} />
}
